import React from "react";

export interface PreventRerenderRootProps {
    innerRef: any;
    className: string;
}

export class PreventRerender extends React.Component<PreventRerenderRootProps> {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        return <div
            ref={this.props.innerRef}
            className={this.props.className}
        />;
    }
}
